import React from "react";
import { Font, StyleSheet, View, Text,Link } from "@react-pdf/renderer";
import styles from "../../../Transcript/SchedulePDFStyles";
import {
  formatDate,
  formatInstructorName,
} from "../../../Transcript/SchedulePDFUtils";

// Font.register({
//   family: 'NotoSans',
//   src: 'https://cdn.jsdelivr.net/npm/@fontsource/noto-sans/files/noto-sans-latin-400-normal.woff',
// });

// Font.register({
//   family: 'NotoSansCyrillic',
//   src: 'https://cdn.jsdelivr.net/npm/@fontsource/noto-sans/files/noto-sans-cyrillic-400-normal.woff',
// });
Font.register({
  family: "NotoSansKR",
  src: "/fonts/NotoSansKR-Regular.ttf",
});
Font.register({
  family: "NotoEthiopic",
  src: "/fonts/NotoSansEthiopic-Regular.ttf",
});
Font.register({
  family: "NotoSans",
  src: "/fonts/NotoSans-Regular.ttf",
});
Font.register({
  family: "NotoSansDevanagari",
  src: "/fonts/NotoSansDevanagari-Regular.ttf",
});
Font.register({
  family: "NotoSansSC",
  src: "/fonts/NotoSansSC-Regular.ttf",
});

Font.register({
  family: "NotoSansArabic",
  src: "/fonts/NotoSansArabic-Regular.ttf",
});
Font.register({
  family: "NotoSansKhmer",
  src: "/fonts/NotoSansKhmer-Regular.ttf",
});
Font.register({
  family: "NotoCombo",
  fonts: [
    { src: "/fonts/NotoSans-Regular.ttf" },
    { src: "/fonts/NotoSansKR-Regular.ttf" },
  ],
});

const detectFont = (text) => {
  // Korean (Hangul)
  if (/[\uAC00-\uD7AF]/.test(text)) return "NotoSansKR";

  // Chinese (Simplified + Traditional)
  if (/[\u4E00-\u9FFF]/.test(text)) return "NotoSansSC";

  // Devanagari (Hindi, Marathi, etc.)
  if (/[\u0900-\u097F]/.test(text)) return "NotoSansDevanagari";

  // Arabic
  if (/[\u0600-\u06FF]/.test(text)) return "NotoSansArabic";

  // Ethiopic (Tigrinya, Amharic)
  if (/[\u1200-\u137F]/.test(text)) return "NotoEthiopic";

  // Khmer
  if (/[\u1780-\u17FF]/.test(text)) return "NotoSansKhmer";

  // Vietnamese (Latin + diacritics)
  if (/[\u0100-\u017F]/.test(text)) return "NotoSans";

  // Basic Latin (English, Somali, etc.)
  if (/[\u0000-\u007F]/.test(text)) return "NotoSans";

  // Default fallback
  return "NotoSans";
};
const SchedulePDFTable = ({ chunk }) => (
  <>
    <View style={[styles.tableRow1, styles.tableHeader, { top: -11 }]}>
      <Text
        style={[styles.tableCell, styles.completed, { fontWeight: "bold" }]}
      >
        Start Date/Time
      </Text>
       <Text
        style={[styles.tableCell, styles.completed, { fontWeight: "bold" }]}
      >
        End Date/Time
      </Text>
      <Text
        style={[styles.tableCell, styles.courseName, { fontWeight: "bold" }]}
        hyphenationCallback={(word) => [word]}
      >
        Course
      </Text>

      <Text style={[styles.tableCell, styles.language, { fontWeight: "bold" }]}>
        Type
      </Text>
      <Text
        style={[styles.tableCell, styles.courseName, { fontWeight: "bold" }]}
      >
        Location
      </Text>
      <Text style={[styles.tableCell, styles.program, { fontWeight: "bold" }]}>
        Language
      </Text>
    </View>
    {chunk && chunk.length > 0 ? (
      chunk.map((item, i) => (
        <View key={i} style={[styles.tableRow, { top: -12 }]}>
          <Text style={[styles.tableCell, styles.completed]}>
            {item.rawDate.replace(/:00 /, ' ')}
          </Text>
<Text style={[styles.tableCell, styles.completed]}>
            {item.rawEndDate.replace(/:00 /, ' ')}
          </Text>
          
          {/* <Text style={[styles.tableCell, styles.courseName,{ fontFamily: 'NotoSans' }]}>{item.coursename}</Text> */}
          <Text
            style={[
              styles.tableCell,
              styles.courseName,
              { fontFamily: detectFont(item.course) },
            ]}
            wrap
            lang="de"
            hyphenationCallback={(word) => [word]}
          >
            {item.course}
          </Text>

          <Text style={[styles.tableCell, styles.language]}>{item.format}</Text>
          <Text style={[styles.tableCell, styles.courseName,{ textAlign: 'left' }]}>
       
                 {item.attendanceType==="online"
    ? 
                      <>Webinar - located in the Caregiver Learning Center.</>

    : 
(() => {
  const roomLine = item?.roomname!="" ? `${item?.roomname} Room` : "";
        const location = item?.location ?? "";
       // const address = item?.locationDetails?.address ?? "";
      //  var roomnameloc=item?.locationDetails?.name ?? "";
        // Safely get the part after the first "-" (or empty string)
      //  const roomPartRaw = roomnameloc.split("-")[1] ?? "";

        // Remove only a single leading space if present
        // const roomPart = roomPartRaw.startsWith(" ")
        //   ? roomPartRaw.slice(1)
        //   : roomPartRaw;

        // If roomPart is empty, suppress the " Room" suffix
       
        return `${location}\n${roomLine}`;
      })()}

                 
    {/* `${item.location}\n${item.locationDetails?.address ?? ""}\n${item.location.split("-")[1].startsWith(" ") ? item.location.split("-")[1].slice(1) : item.location.split("-")[1]} Room`} */}

          </Text>
          <Text style={[styles.tableCell, styles.program]}>
            {item.classLanguage.join(", ") +
              "\n" +
              item.interpreterLanguage.join(", ")}
          </Text>
        </View>
      ))
    ) : (
      <Text style={{ textAlign: "center", marginTop: 10 }}>
        No records found.
      </Text>
    )}
  </>
);

export default SchedulePDFTable;
